import { useEffect, useState } from "react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { TableUpdateStrategy } from "../co-panel/ObjectPanelComponent";
import { CoObjectItem } from "../../interfaces/CoObject";

export interface ObjectsListUpdateFooterState {
  tableUpdateType: TableUpdateStrategy["typeUpdate"];
  teachingBubbleVisible: boolean;
}

export const useObjectsListUpdateFooter = (selectedObjects: Map<string, CoObjectItem>) => {
  const [state, setState] = useState<ObjectsListUpdateFooterState>({
    tableUpdateType: "update",
    teachingBubbleVisible: false,
  });

  const splitUpdateButton = (selectedObjects: Map<string, CoObjectItem>) => {
    return Array.from(selectedObjects.values()).some(
      (item) => item.info.objectType === "TABLE" || item.info.objectType === "CHART"
    );
  };

  const tableUpdateOptions = [
    { key: "update", text: formatMessage("cof.base.update"), depthLevel: "SHALLOWEST" },
    { key: "fullReset", text: formatMessage("cof.updates.fullreset"), depthLevel: "DEEPEST" },
    { key: "keepAllChanges", text: formatMessage("cof.updates.keepallchanges"), depthLevel: "DEEPEST" },
  ];

  const setTableUpdateType = (tableUpdateType: TableUpdateStrategy["typeUpdate"]) => {
    setState((prevState) => ({ ...prevState, tableUpdateType }));
  };

  const toggleTeachingBubble = () => {
    setState((prevState) => ({
      ...prevState,
      teachingBubbleVisible: !prevState.teachingBubbleVisible,
    }));
  };

  useEffect(() => {
    setState((prevState) => ({ ...prevState, tableUpdateType: "update" }));
  }, [splitUpdateButton(selectedObjects)]);

  return {
    state,
    setTableUpdateType,
    tableUpdateOptions,
    splitUpdateButton,
    toggleTeachingBubble,
  };
};
